import { render, staticRenderFns } from "./physical-model.vue?vue&type=template&id=72de14a8"
import script from "./physical-model.vue?vue&type=script&lang=js"
export * from "./physical-model.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72de14a8')) {
      api.createRecord('72de14a8', component.options)
    } else {
      api.reload('72de14a8', component.options)
    }
    module.hot.accept("./physical-model.vue?vue&type=template&id=72de14a8", function () {
      api.rerender('72de14a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/device/physical-model.vue"
export default component.exports